module.exports = __webpack_public_path__ + "img/mutianyu2.0c6b86d7.jpg";